module.exports = __webpack_public_path__ + "img/pagination-more.d72b55a5.svg";